import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as w, S as g } from "./icons.types-0722eef5.js";
function p({ title: c, titleId: h, size: i, width: s, height: n, extended: r = !1, ...t }) {
  const o = r ? w : g, a = i ? o[i] : s || o[r ? "s" : "l"], e = i ? o[i] : n || o[r ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: a,
      height: e,
      "aria-labelledby": h,
      ...t,
      children: [
        c ? /* @__PURE__ */ l("title", { id: h, children: c }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Show_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M64.36 35.694C59.815 31.698 48.833 23.4 36 23.4c-12.836 0-23.816 8.302-28.359 12.297l3.11 2.103c3.032-2.56 8.353-6.49 14.795-8.83A12.537 12.537 0 0 0 23.4 36c0 6.959 5.641 12.6 12.6 12.6S48.6 42.959 48.6 36a12.53 12.53 0 0 0-2.142-7.03c6.439 2.337 11.756 6.272 14.787 8.83l3.116-2.106ZM36 45c-4.962 0-9-4.038-9-9 0-4.963 4.038-9 9-9 4.963 0 9 4.037 9 9 0 4.962-4.037 9-9 9Zm5.4-9a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Show_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as Show
};
